import clsx from 'clsx';

import { Text } from '@northladder/i18n';
import { TTextLocalized } from '@northladder/utilities';

import { VerticalSingleEndBannerSVG } from './VerticalSingleEndBannerSVG';

interface IVerticalSingleEndBannerProps {
  className?: string;
  subtitle: TTextLocalized;
  title: TTextLocalized;
}

/**
 * -----------------------------------------------------------------------------
 * This renders a vertical emblem banner with just one banner and and the other
 * folded. This variant displays a title & subtitle in the center of the banner.
 */
export function VerticalSingleEndBanner({
  className,
  subtitle,
  title,
}: IVerticalSingleEndBannerProps) {
  return (
    <div className={clsx('relative w-48', className)}>
      <VerticalSingleEndBannerSVG className="rtl:scale-x-[-1] rtl:transform" />
      <p
        className="
          absolute left-0 right-8  top-0 flex h-2/3 w-11/12 flex-col items-center
          justify-center overflow-hidden pt-12 text-4xl text-white
          rtl:left-8 rtl:right-0
       "
      >
        <Text className="font-light" text={title} />
        <Text className="font-bold" text={subtitle} />
      </p>
    </div>
  );
}
